import React from "react";
import { Button, Form, FormControl, Row, Modal, CloseButton } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { notification } from "antd";

import { put, post, getBranchOwner, api } from "@config";
import { validateCPF, validateCNPJ } from "@parts/document-component"

import { Document, PersonType } from '@parts'
import { setPersonDoc } from "../../../parts/document-component/actions"

import StateLocation from "@parts/address-component/state-location";
import CityLocation from "@parts/address-component/city-location";
import List from "./list";

import Address from '@parts/address-component'

import {
  setStateLocation,
  setCityLocation,
  setStreet,
} from "@parts/address-component/actions";
import { setPersonType } from '@parts/person-type-component/actions'

import { getStates } from "@parts/utils";

const DEFAULT_STATE = {
  addModal: false,
  edit: false,
  personType: "0",
  name: "",
  isCpf: false,
  cpf: "",
  cnpj: "",
  ie: "",
  doc: "",
  street: "",
  errors: []
};

class NFeTransporter extends React.Component {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;
    this.handaleSaveNFeTransporter = this.handaleSaveNFeTransporter.bind(this);
    this.handleChangePersonType = this.handleChangePersonType.bind(this);
    this._onSetItemToEdit = this._onSetItemToEdit.bind(this);
    this._resetData = this._resetData.bind(this);
  }

  onOpenModal() {
    this.setState({ ...this, addModal: true });
  }

  handleChangePersonType(e) {

    this.props.setPersonType(e.target.value)
    this.setState({ ...this, personType: e.target.value, doc: "" });
  }

  validate() {
    const { cityLocation: city_location, street, doc, type } = this.props;
    const { name, ie, personType } = this.state;

    let errors = []

    if (!name.length || name.length <= 3) {
      errors.push("Nome inválido")
    }

    if (personType == "0") {
      if (!validateCPF(doc)) {
        errors.push("CPF inválido")
      }
    } else {
      if (!validateCNPJ(doc)) {
        errors.push("CNPJ inválido")
      }
      if (!ie.length) {
        errors.push("IE inválido")
      }
    }

    if (!city_location.value) {
      errors.push("Cidade inválida")
    }

    if (!street.length) {
      errors.push("Rua inválida")
    }


    this.setState({ ...this, errors })

    return errors.length
  }

  handaleSaveNFeTransporter() {
    const branch = getBranchOwner().id;
    const { cityLocation: city_location, stateLocation: state_location, postalCode: postal_code, street } = this.props;

    if (this.validate()) {
      return
    }

    const urlCreate = `${api.nfeTransporter}?branch_owner=${branch}`;
    const urlUpdate = `${api.nfeTransporter}${this.state.id}/?branch_owner=${branch}`;

    const payload = (resp) => {
      this._resetData();
      notification.open({
        message: this.state.edit
          ? "Atualizado com sucesso"
          : "Criado com sucesso",
        type: "success",
        duration: 3,
        key: 64,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    };
    const data = {
      name: this.state.name,
      street,
      city_location: city_location.value,
      state_location: state_location.value,
      state_registry: this.state.ie,
    };
    data[this.state.personType == "1" ? "cnpj" : "cpf"] = this.props.doc;
    if (this.state.edit) {
      put(urlUpdate, data, payload);
    } else {
      post(urlCreate, data, payload);
    }
  }

  _setCityLocation(city_location) {
    city_location.label = city_location.city_name;
    city_location.value = city_location.id;
    this.props.setCityLocation(city_location);
  }
  _getSate(city_location) {
    const payload = (states) => {
      const [state] = states;
      state.label = state.uf;
      state.value = state.id;
      this.props.setStateLocation(state);
      this._setCityLocation(city_location);
    };
    getStates(payload, city_location.uf_code);
  }
  _onSetItemToEdit(item) {
    if (item.city_location) {
      const { city_location } = item;
      this._getSate(city_location);
    }

    const doc = item.cpf ? item.cpf : item.cnpj

    this.setState({
      ...this,
      addModal: true,
      edit: true,
      id: item.id,
      name: item.name,
      doc,
      personType: item.cpf ? "0" : "1",
      ie: item.state_registry,
    });
    this.props.setStreet(item.street)
    this.props.setPersonType(item.cpf ? "0" : "1")
    this.props.setPersonDoc(doc)
  }
  UNSAFE_componentWillMount() { }

  render() {
    return (
      <div>
        <Row className="my-2">
          <h2 className="pl-3 my-auto">Transportadora(s)</h2>
          <div className="pl-2 my-auto">
            <Button size="sm" onClick={() => this.onOpenModal()}>
              Adicionar
            </Button>
          </div>
        </Row>
        <List edit onEdit={this._onSetItemToEdit} />
        <Modal show={this.state.addModal} closable={false} size='lg'>
          <div className="float-right">
          <CloseButton onClick={this._resetData}/>
          </div>
          <Modal.Header>
            <h2>{this.state.edit ? "Editar" : "Cadastrar"} tranportadora</h2>
          </Modal.Header>
          <Modal.Body>
            {
              this.state.errors.length ?
                <ul className='text-danger' >{this.state.errors.map(e => <li>{e}</li>)}</ul>
                :
                <div />
            }

            <div className="form-group">
              <label htmlFor="">Selecione o tipo</label>
              <select
                onChange={this.handleChangePersonType}
                name=""
                id=""
                className="form-control"
              >
                <option selected={this.state.personType === "0"} value="0">
                  Pessoa Física
                </option>
                <option selected={this.state.personType === "1"} value="1">
                  Pessoa Júridica
                </option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="">* Informe sua razão social</label>
              <FormControl
                placeholder="Informe sua razão social"
                onChange={(e) =>
                  this.setState({ ...this, name: e.target.value })
                }
                aria-describedby="nfe-transporter-name"
                value={this.state.name}
              />
            </div>

            <div className="form-group py-2">
              <Document required />
            </div>

            {this.state.personType === "1" ? (
              <React.Fragment>
                <label className="pt-2">* IE (Inscrição Estadual)</label>
                <FormControl
                  placeholder="Digite aqui"
                  onChange={(e) =>
                    this.setState({
                      ...this,
                      ie: e.target.value.replace(/\D+/g, ""),
                    })
                  }
                  value={this.state.ie}
                />
                <a
                  className="my-2"
                  href="https://dfe-portal.svrs.rs.gov.br/NFE/CCC"
                  target="_blank"
                >
                  Clique aqui para buscar a Inscrição Estadual
                </a>
              </React.Fragment>
            ) : (
              <div />
            )}

            <Address onlyStateCity hidePostalCode={this.state.edit} />
          </Modal.Body>

          <Modal.Footer>
            <Button variant="danger" onClick={this._resetData}>
              Voltar
            </Button>
            <Button onClick={this.handaleSaveNFeTransporter}>
              {this.state.edit ? "Editar" : "Adicionar"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  _resetData() {
    this.setState({
      ...this,
      ...DEFAULT_STATE,
    });
    this.props.setStateLocation("")
    this.props.setCityLocation("")
    this.props.setStreet("")
    this.props.setPersonDoc("")
    this.props.setPersonType(0)
  }
}
const mapStateToProps = (state) => ({
  cityLocation: state.cityLocation,
  stateLocation: state.stateLocation,
  postalCode: state.postalCode,
  street: state.street,
  doc: state.personDoc
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setStateLocation,
      setCityLocation,
      setStreet,
      setPersonDoc,
      setPersonType
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(NFeTransporter);



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/transporter/index.jsx